module.exports = __webpack_public_path__ + "static/media/limit-exceeded-info.291ea341.svg";